import React from "react";
import { MapPin, Leaf, Anchor } from "lucide-react";

const PORTONOVO_IMG = "https://customer-assets.emergentagent.com/job_vela-autentica/artifacts/j0q4oeq2_FOTO%20WEB%20PORTONOVO%20%282%29.jpg";

export default function Portonovo() {
  return (
    <section id="portonovo" className="section-pad relative overflow-hidden wood-bg" data-testid="portonovo-section">
      {/* Subtle nautical chart background */}
      <div className="absolute inset-0 pointer-events-none opacity-[0.07]" aria-hidden="true">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="nautical-grid" width="120" height="120" patternUnits="userSpaceOnUse">
              <path d="M 120 0 L 0 0 0 120" fill="none" stroke="#0A192F" strokeWidth="0.6"/>
              <circle cx="60" cy="60" r="1.4" fill="#0A192F"/>
              <path d="M 56 60 L 64 60 M 60 56 L 60 64" stroke="#0A192F" strokeWidth="0.6"/>
            </pattern>
            <pattern id="nautical-fine" width="24" height="24" patternUnits="userSpaceOnUse">
              <path d="M 24 0 L 0 0 0 24" fill="none" stroke="#0A192F" strokeWidth="0.25" opacity="0.6"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#nautical-fine)"/>
          <rect width="100%" height="100%" fill="url(#nautical-grid)"/>
          {/* Compass rose */}
          <g transform="translate(120,160)" stroke="#0A192F" fill="none" strokeWidth="0.8">
            <circle r="60"/><circle r="44"/>
            <path d="M0,-60 L6,0 L0,60 L-6,0 Z" fill="#0A192F" opacity="0.5"/>
            <path d="M-60,0 L0,-6 L60,0 L0,6 Z" fill="#0A192F" opacity="0.3"/>
            <text y="-66" textAnchor="middle" fontSize="9" fontFamily="serif" fill="#0A192F">N</text>
          </g>
          {/* Coordinates labels */}
          <text x="40" y="40" fontSize="10" fontFamily="serif" fill="#0A192F" opacity="0.6">42°23'N</text>
          <text x="40" y="56" fontSize="10" fontFamily="serif" fill="#0A192F" opacity="0.6">8°48'W</text>
        </svg>
      </div>

      <div className="container-tight relative grid md:grid-cols-12 gap-12 md:gap-16 items-center">
        <div className="md:col-span-7">
          <p className="label-eyebrow text-wood mb-4">Base de salida</p>
          <h2 className="font-heading text-4xl md:text-5xl leading-tight text-navy" data-testid="portonovo-title">
            Portonovo, en el corazón de las Rías Baixas.
          </h2>
          <p className="mt-6 text-navy/80 text-lg leading-relaxed">
            El Zorba tiene su base de salida en Portonovo, una ubicación privilegiada para navegar por la <strong>ría de Pontevedra</strong>, el entorno de <strong>Sanxenxo</strong> y las aguas próximas al <strong>Parque Nacional das Illas Atlánticas de Galicia</strong>.
          </p>
          <p className="mt-5 text-navy/75 text-base md:text-lg leading-relaxed">
            Desde aquí se pueden diseñar salidas privadas adaptadas a la meteorología, la temporada y el tipo de experiencia: navegación tranquila, fondeos según condiciones, atardeceres, encuentros privados o jornadas completas en el mar.
          </p>

          <div className="mt-10 grid sm:grid-cols-3 gap-6">
            <div className="flex items-start gap-3">
              <Anchor size={20} className="text-wood mt-1 flex-shrink-0" strokeWidth={1.5} />
              <div>
                <p className="font-heading text-lg text-navy">Portonovo</p>
                <p className="text-sm text-navy/60">Sanxenxo · Pontevedra</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <MapPin size={20} className="text-wood mt-1 flex-shrink-0" strokeWidth={1.5} />
              <div>
                <p className="font-heading text-lg text-navy">Rías Baixas</p>
                <p className="text-sm text-navy/60">Ons, Cíes y costa de la ría</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <Leaf size={20} className="text-wood mt-1 flex-shrink-0" strokeWidth={1.5} />
              <div>
                <p className="font-heading text-lg text-navy">Navegación responsable</p>
                <p className="text-sm text-navy/60">Respeto al mar y al entorno protegido</p>
              </div>
            </div>
          </div>
        </div>

        <div className="md:col-span-5">
          <img
            src={PORTONOVO_IMG}
            alt="Costa de las Rías Baixas, entorno del Parque Nacional das Illas Atlánticas"
            className="w-full h-[420px] md:h-[560px] object-cover rounded-md shadow-xl"
          />
        </div>
      </div>
    </section>
  );
}
